import { render, staticRenderFns } from "./ModalOption.vue?vue&type=template&id=96e17b30&scoped=true"
import script from "./ModalOption.vue?vue&type=script&lang=js"
export * from "./ModalOption.vue?vue&type=script&lang=js"
import style0 from "./ModalOption.vue?vue&type=style&index=0&id=96e17b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e17b30",
  null
  
)

export default component.exports